export const getDefaultQueryString = (
  field: string,
  value: string | number,
) => {
  return `?search=${field} eq ${value}`
}

export const getLimitQueryString = (field: string, value: string | number) => {
  return `?limit=1000&search=${field} eq ${value}`
}
